<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-alert type="info" show-icon style="margin-bottom: 24px" message="分销佣金规则说明">
        <template slot="description">
          <div>全局开关关闭后，所有用户在被邀请人成交时均不再获得分销佣金（与用户个人分销开关叠加生效）。</div>
          <div style="margin-top: 4px">仅一级分销：邀请人只获得直接邀请用户的成交佣金，二级及以下下级成交不会产生佣金。</div>
          <div style="margin-top: 4px">分销时间：仅在此时间段内审核通过的订单才会发放佣金；开始/结束时间留空表示不限制。</div>
          <div style="margin-top: 4px">佣金 = 被邀请人订单到账金额 × 佣金比例。</div>
          <div style="margin-top: 4px">以下时间字段均按 <strong>尼日利亚时间 (Africa/Lagos, UTC+1)</strong> 录入并存储。</div>
        </template>
      </a-alert>

      <a-spin :spinning="loading">
        <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 14 }">
          <a-form-model-item label="启用分销">
            <a-switch
              :checked="form.referralEnabled === 1"
              checked-children="是"
              un-checked-children="否"
              @change="onReferralEnabledChange"
            />
          </a-form-model-item>

          <a-form-model-item v-if="form.referralEnabled === 1" label="佣金比例 (%)" required>
            <a-input-number
              v-model="form.referralRatePercent"
              :min="0.01"
              :max="100"
              :step="0.01"
              :precision="2"
              style="width: 240px"
            />
            <div class="form-tip">例如 1 表示邀请人获得订单到账金额的 1% 作为佣金</div>
          </a-form-model-item>

          <a-form-model-item label="分销开始时间">
            <a-date-picker
              v-model="form.validStartTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="留空表示不限制"
              style="width: 320px"
              allow-clear
            />
            <div class="form-tip">按尼日利亚时间 (UTC+1) 录入</div>
          </a-form-model-item>

          <a-form-model-item label="分销结束时间">
            <a-date-picker
              v-model="form.validEndTime"
              show-time
              format="YYYY-MM-DD HH:mm:ss"
              value-format="YYYY-MM-DD HH:mm:ss"
              placeholder="留空表示不限制"
              style="width: 320px"
              allow-clear
            />
            <div class="form-tip">按尼日利亚时间 (UTC+1) 录入</div>
          </a-form-model-item>

          <a-form-model-item v-if="form.referralEnabled === 1 && previewAmount > 0" label="示例计算">
            <div class="preview-box">
              <div>被邀请人订单到账 {{ previewAmount }}，邀请人佣金 {{ previewBonus }}</div>
            </div>
          </a-form-model-item>

          <a-form-model-item :wrapper-col="{ span: 14, offset: 5 }">
            <a-button type="primary" :loading="submitLoading" @click="submitForm">保存配置</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getReferralConfig, saveReferralConfig } from '@/api/giftcard/referralConfig'

export default {
  name: 'GiftcardReferralConfig',
  data() {
    return {
      loading: false,
      submitLoading: false,
      previewAmount: 1000,
      form: {
        referralEnabled: 1,
        referralRatePercent: 1,
        validStartTime: null,
        validEndTime: null
      }
    }
  },
  computed: {
    previewBonus() {
      if (this.form.referralEnabled !== 1 || !this.form.referralRatePercent) return 0
      return Number((this.previewAmount * this.form.referralRatePercent / 100).toFixed(2))
    }
  },
  created() {
    this.loadConfig()
  },
  methods: {
    loadConfig() {
      this.loading = true
      getReferralConfig().then(res => {
        const data = res.data || {}
        this.form = {
          referralEnabled: data.referralEnabled == null ? 0 : data.referralEnabled,
          referralRatePercent: data.referralRatePercent != null ? Number(data.referralRatePercent) : 1,
          validStartTime: data.validStartTime || null,
          validEndTime: data.validEndTime || null
        }
      }).finally(() => { this.loading = false })
    },
    onReferralEnabledChange(checked) {
      this.form.referralEnabled = checked ? 1 : 0
    },
    submitForm() {
      if (this.form.referralEnabled === 1) {
        if (!this.form.referralRatePercent || this.form.referralRatePercent <= 0) {
          this.$message.warning('启用分销时请填写大于0的佣金比例')
          return
        }
      }
      if (this.form.validStartTime && this.form.validEndTime &&
          new Date(this.form.validStartTime).getTime() >= new Date(this.form.validEndTime).getTime()) {
        this.$message.warning('分销开始时间须早于结束时间')
        return
      }
      const payload = {
        referralEnabled: this.form.referralEnabled,
        referralRatePercent: this.form.referralRatePercent,
        validStartTime: this.form.validStartTime || null,
        validEndTime: this.form.validEndTime || null
      }
      this.submitLoading = true
      saveReferralConfig(payload).then(() => {
        this.$message.success('保存成功')
        this.loadConfig()
      }).finally(() => { this.submitLoading = false })
    }
  }
}
</script>

<style scoped>
.form-tip { color: rgba(0, 0, 0, 0.45); font-size: 12px; margin-top: 4px; }
.preview-box { color: rgba(0, 0, 0, 0.65); font-size: 13px; }
</style>
